import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../../api.service";
import { AuthService } from "../../../services/auth.service";
import {
  PreviewTestEmailRequest,
  PreviewTestEmailResponse,
  SendTestEmailRequest,
  SendTestEmailResponse,
  TestEmailTemplate,
} from "./data/email-template.models";

@Injectable({
  providedIn: "root",
})
export class EmailTemplatesControllerService {
  private readonly resourceUrl = "/emails/test";

  constructor(private apiService: ApiService) {}

  getTemplates(): Observable<TestEmailTemplate[]> {
    return this.apiService.get<TestEmailTemplate[]>(
      `${this.resourceUrl}/templates`,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  previewTemplate(
    request: PreviewTestEmailRequest,
  ): Observable<PreviewTestEmailResponse> {
    return this.apiService.post<PreviewTestEmailResponse>(
      `${this.resourceUrl}/preview`,
      request,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  sendTestEmail(
    request: SendTestEmailRequest,
  ): Observable<SendTestEmailResponse> {
    return this.apiService.post<SendTestEmailResponse>(
      `${this.resourceUrl}/send`,
      request,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }
}
